import { ApiConfig } from "common/models";
import { buildEngApiUrl } from "common/utils/api.util";
import {
  LinkMocDocumentsRequest,
  MocRequest,
  AssessmentType,
  UpdateDecisionSummaryRequest
} from "../models/moc.model";

export const mocApiConfig = {
  getMocs: (): ApiConfig =>
    new ApiConfig(
      buildEngApiUrl(
        "mocs?page=1&page_size=1000&sort_by=lastUpdated&sort_order=desc"
      ),
      "GET"
    ),
  getMocById: (mocId: string): ApiConfig =>
    new ApiConfig(buildEngApiUrl(`mocs/${mocId}`), "GET"),
  getMocEngineeringAnalysis: (mocId: string): ApiConfig =>
    new ApiConfig(buildEngApiUrl(`mocs/${mocId}/engineering-analysis`), "GET"),
  getMocImpactAssessment: (mocId: string): ApiConfig =>
    new ApiConfig(
      buildEngApiUrl(`mocs/${mocId}/engineering-assessment/impacts`),
      "GET"
    ),
  getMocRiskAssessment: (mocId: string): ApiConfig =>
    new ApiConfig(
      buildEngApiUrl(`mocs/${mocId}/engineering-assessment/risks`),
      "GET"
    ),
  getMocActionRegister: (mocId: string): ApiConfig =>
    new ApiConfig(
      buildEngApiUrl(`mocs/${mocId}/engineering-assessment/actions`),
      "GET"
    ),
  getMocSafeguards: (mocId: string): ApiConfig =>
    new ApiConfig(
      buildEngApiUrl(`mocs/${mocId}/engineering-assessment/safeguards`),
      "GET"
    ),
  updateAssessmentStatus: (
    assessmentType: AssessmentType,
    assessmentId: string,
    status: string
  ): ApiConfig =>
    new ApiConfig(
      buildEngApiUrl(
        `mocs/engineering-assessment/${assessmentType}/${assessmentId}/status?status=${status}`
      ),
      "PATCH"
    ),
  createMoc: (payload: MocRequest): ApiConfig =>
    new ApiConfig(buildEngApiUrl("mocs"), "POST", "", payload),
  updateMoc: (mocId: string, payload: MocRequest): ApiConfig =>
    new ApiConfig(buildEngApiUrl(`mocs/${mocId}`), "PUT", "", payload),
  addMocDocuments: (
    mocId: string,
    payload: LinkMocDocumentsRequest
  ): ApiConfig =>
    new ApiConfig(
      buildEngApiUrl(`mocs/${mocId}/documents`),
      "POST",
      "",
      payload
    ),
  // Reuses the document Upload endpoint; the generated report PDF is sent as
  // "files" and the backend stores it against the moc id under "MOC Report".
  generateFinalMocReport: (mocId: string, file: Blob): ApiConfig => {
    const formData = new FormData();
    formData.append("files", file, `MOC-Report-${mocId}.pdf`);
    formData.append("file_category", "MOC Report");
    // moc id field name varies across binders; send all accepted casings.
    formData.append("MocId", mocId);
    formData.append("moc_id", mocId);
    formData.append("mocId", mocId);
    return new ApiConfig(
      buildEngApiUrl("Documents/Upload"),
      "POST",
      "",
      formData
    );
  },
  getMocDocumentAccessDetails: (mocId: string): ApiConfig =>
    new ApiConfig(
      buildEngApiUrl(`mocs/${mocId}/document/access-details`),
      "GET"
    ),
  getMocDecisionPackage: (mocId: string): ApiConfig =>
    new ApiConfig(
      buildEngApiUrl(`mocs/${mocId}/decision-packing-review`),
      "GET"
    ),
  getMocHistory: (mocId: string): ApiConfig =>
    new ApiConfig(buildEngApiUrl(`mocs/${mocId}/history`), "GET"),
  updateDecisionSummary: (
    mocId: string,
    payload: UpdateDecisionSummaryRequest
  ): ApiConfig =>
    new ApiConfig(
      buildEngApiUrl(`mocs/${mocId}/decision-packing-review/summary`),
      "PATCH",
      "",
      payload
    )
};
